import { FieldOption } from './accountTypes'

const userFlags: FieldOption[] = [
  { value: 'fsp_alumni', name: 'FSP Alumni' },
  { value: 'tenured', name: 'Tenured' }
]

export default userFlags
